import localforage from "localforage";

const safestorage = localforage.createInstance({
  name: import.meta.env.VITE_APP_NAME
});

safestorage.setDriver(localforage.LOCALSTORAGE);

export default safestorage
